import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper, { MaintainerConstants } from 'features/Maintainer/maintainerHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import KTCalendar from 'general/components/OtherKeenComponents/KTCalendar';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import DoughnutChartJS from 'general/components/quybka/Charts/DoughnutChartJS';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import EmptyView from 'general/components/Others/EmptyView';
import useRouter from 'hooks/useRouter';

MaintainerDashboardView.propTypes = {};

function MaintainerDashboardView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { user } = useSelector((state) => state.auth);
    // thong ke trang thai cong viec
    const [ticketSummary, setTicketSummary] = useState({});
    const [ticketSummaryFilter, setTicketSummaryFilter] = useState({
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    })
    // thong ke chi so cua KTV
    const [maintainerReport, setMaintainerReport] = useState({});
    // thong ke loai yeu cau
    const [ticketStatistics, setTicketStatistics] = useState({});
    const [ticketStatisticsFilter, setTicketStatisticsFilter] = useState({
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    })
    // bieu do
    const [chartData, setChartData] = useState({});
    const [chartFilter, setChartFilter] = useState({
        status: '',
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    });
    const [chartFilterDropdown, setChartFilterDropdown] = useState({
        status: '',
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    });
    // danh sach yeu cau
    const [ticketList, setTicketList] = useState({});
    const [ticketFilter, setTicketFilter] = useState({
        type: '',
        priority: '',
        status: '',
        deadlineFrom: getDateFilterOption(dateFilter.tuanNay)[0].format('YYYY-MM-DD'),
        deadlineTo: getDateFilterOption(dateFilter.tuanNay)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.tuanNay,
    })
    const [ticketFilterDropdown, setTicketFilterDropdown] = useState({
        type: '',
        priority: '',
        status: '',
        deadlineFrom: getDateFilterOption(dateFilter.tuanNay)[0].format('YYYY-MM-DD'),
        deadlineTo: getDateFilterOption(dateFilter.tuanNay)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.tuanNay,
    })

    useEffect(() => {
        requestGetTicketSummary(ticketSummaryFilter);
    }, [ticketSummaryFilter])

    useEffect(() => {
        requestGetTicketStatistics(ticketStatisticsFilter);
    }, [ticketStatisticsFilter])

    useEffect(() => {
        requestGetMaintainerReport();
    }, [])

    useEffect(() => {
        requestGetDashboardDaily(chartFilter);
    }, [chartFilter])

    useEffect(() => {
        requestGetTicketList(ticketFilter);
    }, [ticketFilter])

    // thong ke cong viec da nhan
    const chartTicketByDateEl = useMemo(() => {
        const ticketByDate = chartData?.ticketByDate ?? [];
        let labels = ticketByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = ticketByDate?.map((item) => item.tickets ?? 0);
        if (ticketByDate?.length > 31) {
            const groupedData = _.groupBy(ticketByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.tickets, 0);
                return total
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê công việc đã nhận"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' công việc'
                }
                valueColor="rgba(48, 189, 111, 1)"
                actionEl={
                    <DropdownFilterTable
                        id="ticket"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Trạng thái công việc"
                                    filterKey="status"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...MaintainerHelper.Data.maintainerTicketStatusOptions,
                                    ]}
                                    selectedValue={chartFilterDropdown.status}
                                    handleChange={(value) => {
                                        setChartFilterDropdown({ ...chartFilterDropdown, status: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={chartFilterDropdown.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setChartFilterDropdown({
                                            ...chartFilterDropdown,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                status: '',
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setChartFilter(updateChartFilter);
                            setChartFilterDropdown(updateChartFilter);
                        }}
                        saveFilter={() => {
                            setChartFilter(chartFilterDropdown);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            chartFilter,
                            dateFilter.baMuoiNgayGanNhat,
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Công việc"
                        unit="công việc"
                        labels={labels}
                        data={data}
                        color="rgba(48, 189, 111, 0.3)"
                        hoverColor="rgba(48, 189, 111, 1)"
                    />
                }
            />
        );
    }, [chartData, chartFilter, chartFilterDropdown]);

    const maintainCalendar = useMemo(() => {
        return (
            <div>
                <div className='d-flex justify-content-between'>
                    {UIHelper.buildCardHeader('Lịch bảo trì, sửa chữa', false, null, false, true)}
                    <div className='p-4'>
                        <DropdownFilterTable
                            id="calendar"
                            isLightButton={true}
                            toggleElementBorderRadius={10}
                            filterComponent={[
                                <div className='row'>
                                    <div className="col-6 pr-2">
                                        <KTDropdownFilter
                                            label="Loại công việc"
                                            filterKey="type"
                                            options={[
                                                { name: 'Tất cả', value: '' },
                                                ...MaintainerHelper.Data.ticketTypeOptions,
                                            ]}
                                            selectedValue={ticketFilterDropdown.type}
                                            handleChange={(value) => {
                                                setTicketFilterDropdown({ ...ticketFilterDropdown, type: value });
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 pl-2">
                                        <KTDropdownFilter
                                            label="Độ ưu tiên"
                                            filterKey="priority"
                                            options={[
                                                { name: 'Tất cả', value: '' },
                                                ...MaintainerHelper.Data.ticketPriorityOptions,
                                            ]}
                                            selectedValue={ticketFilterDropdown.priority}
                                            handleChange={(value) => {
                                                setTicketFilterDropdown({ ...ticketFilterDropdown, priority: value });
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 pr-2">
                                        <KTDropdownFilter
                                            label="Trạng thái công việc"
                                            filterKey="status"
                                            options={[
                                                { name: 'Tất cả', value: '' },
                                                ...MaintainerHelper.Data.maintainerTicketStatusOptions,
                                            ]}
                                            selectedValue={ticketFilterDropdown.status}
                                            handleChange={(value) => {
                                                setTicketFilterDropdown({ ...ticketFilterDropdown, status: value });
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 mt-2 pl-2">
                                        <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                            Khoảng thời gian thống kê
                                        </label>
                                        <CustomDateRangePicker
                                            alignRight={true}
                                            toggleFontWeight="600"
                                            toggleElementBorderRadius={5}
                                            initialValue={ticketFilterDropdown.selectedValue}
                                            onPressSave={(selectedValue, startDate, endDate) => {
                                                setTicketFilterDropdown({
                                                    ...ticketFilterDropdown,
                                                    deadlineFrom: startDate,
                                                    deadlineTo: endDate,
                                                    selectedValue: selectedValue,
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            ]}
                            resetDefaultTable={() => {
                                const updateTicketFilter = {
                                    type: '',
                                    priority: '',
                                    status: '',
                                    deadlineFrom: getDateFilterOption(dateFilter.tuanNay)[0].format('YYYY-MM-DD'),
                                    deadlineTo: getDateFilterOption(dateFilter.tuanNay)[1].format('YYYY-MM-DD'),
                                    selectedValue: dateFilter.tuanNay,
                                };
                                setTicketFilter(updateTicketFilter);
                                setTicketFilterDropdown(updateTicketFilter);
                            }}
                            saveFilter={() => {
                                setTicketFilter(ticketFilterDropdown);
                            }}
                            isDefaultFilter={Utils.checkDefaultFilter(
                                ['selectedValue', 'deadlineFrom', 'deadlineTo'],
                                ticketFilter,
                                dateFilter.tuanNay,
                            )}
                        />
                    </div>
                </div>
                <div>
                    {ticketList?.length
                        ? <KTCalendar
                            tickets={ticketList}
                            startDate={ticketFilter?.deadlineFrom}
                            endDate={ticketFilter?.deadlineTo}
                            selectedValue={ticketFilter?.selectedValue}
                        />
                        : <EmptyView
                            icon={imgEmptyNoData}
                            title="Không có dữ liệu để hiển thị"
                            text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                        />
                    }
                </div>
            </div>
        );
    }, [ticketList, ticketFilter, ticketFilterDropdown])

    // MARK: ---- METHODS ----
    const requestGetTicketSummary = (filter) => {
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        MaintainerHelper.API.requestGetTicketSummary(params).then(
            (res) => {
                setTicketSummary(res ?? {});
            }
        );
    };
    const requestGetTicketStatistics = (filter) => {
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        MaintainerHelper.API.requestGetTicketStatistics(params).then((res) => {
            setTicketStatistics(res ?? {});
        });
    };

    const requestGetMaintainerReport = () => {
        MaintainerHelper.API.requestGetMaintainerReport({}).then((res) => {
            setMaintainerReport(res ?? {});
        });
    };

    const requestGetDashboardDaily = (filter) => {
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        MaintainerHelper.API.requestGetDashboardDaily(params).then((res) => {
            setChartData(res ?? {});
        });
    };

    const requestGetTicketList = (filter) => {
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        MaintainerHelper.API.requestGetMyTicket(params).then((res) => {
            setTicketList(res?.tickets ?? {});
        });
    };

    return (
        <div className="mt-4" style={{ minHeight: '1200px' }}>
            {/* header */}
            <div className="row m-0 p-0 px-2">
                <div className="col-lg-6 mb-4 px-2">
                    {UIHelper.buildCard(
                        <div>
                            <div
                                className="d-flex flex-column p-4"
                                style={{
                                    borderBottom: `1px solid ${AppColors.gray[200]}`,
                                }}
                            >
                                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                                    {user?.fullname}
                                </span>
                                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                                    {ChargeHelper.Utils.getUserRoleName(user?.role).toUpperCase()}
                                </span>
                            </div>
                            <div className="d-flex flex-column gap-3 pt-2 pb-6">
                                <div className="px-4 d-flex flex-column gap-3 mt-4">
                                    {UIHelper.buildStatisticItem(
                                        '#537EC9',
                                        <div className="d-flex align-items-center gap-2">
                                            Thời gian trung bình một công việc
                                        </div>,
                                        Utils.convertSecondsToHMSText(maintainerReport?.averageTime ?? 0),
                                        null,
                                        'fa-solid fa-business-time'
                                    )}
                                    {UIHelper.buildStatisticItem(
                                        '#58B7C6',
                                        <div className="d-flex align-items-center gap-2">
                                            Tổng thu nhập dự kiến{' '}
                                            <KTTooltip
                                                text={`<div><span>Số tiền dự kiến được nhận của kỹ thuật viên từ trước đến nay.</span><br />
                                                    <span>• Thu nhập đã nhận: ${Utils.formatNumber(
                                                    maintainerReport?.totalIncome?.receivedIncome ?? 0
                                                )} VNĐ</span><br /><span>• Thu nhập chưa nhận: ${Utils.formatNumber(
                                                    maintainerReport?.totalIncome?.pendingIncome ?? 0
                                                )} VNĐ</span></div>`}
                                                textHeader="Tổng thu nhập dự kiến"
                                                isHtmlContent
                                            >
                                                <i
                                                    className="fa-regular fa-info-circle"
                                                    style={{ color: AppColors.primary }}
                                                />
                                            </KTTooltip>
                                        </div>,
                                        `${Utils.formatNumber(
                                            _.sum([
                                                maintainerReport?.totalIncome?.pendingIncome ?? 0,
                                                maintainerReport?.totalIncome?.receivedIncome ?? 0,
                                            ])
                                        )} VNĐ`,
                                        AppResource.icons.icExpectedRevenue,
                                        null
                                    )}
                                    {UIHelper.buildStatisticItem(
                                        '#30BD6F',
                                        <div className="d-flex align-items-center gap-2">
                                            Số công việc hoàn thành trong tháng
                                        </div>,
                                        Utils.formatNumber(maintainerReport?.monthlyCompleted ?? 0),
                                        null,
                                        'fa-solid fa-list-check'
                                    )}
                                </div>
                            </div>
                        </div>,
                        false
                    )}
                </div>
                {/* tong so cong viec da nhan */}
                <div className="col-lg-6 mb-4 px-2">
                    {UIHelper.buildCard(
                        <div className='h-100'>
                            <div className='d-flex justify-content-between'>
                                {UIHelper.buildCardHeader('Tổng số công việc đã nhận', false, null, false, true)}
                                <div className='p-4'>
                                    <CustomDateRangePicker
                                        alignRight={true}
                                        toggleFontWeight="600"
                                        toggleElementBorderRadius={10}
                                        initialValue={chartFilter.selectedValue}
                                        onPressSave={(selectedValue, startDate, endDate) => {
                                            setTicketStatisticsFilter({
                                                from: startDate,
                                                to: endDate,
                                                selectedValue: selectedValue,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="px-4 pb-4 d-flex align-items-center gap-3 h-75 w-100">
                                <div
                                    className=""
                                    style={{
                                        height: '200px',
                                        width: '200px',
                                    }}
                                >
                                    <DoughnutChartJS
                                        showTitle={false}
                                        showLegend={false}
                                        labels={[
                                            'Bảo trì',
                                            'Sửa chữa',
                                        ]}
                                        datasets={[
                                            {
                                                data: [
                                                    ticketStatistics[MaintainerConstants.TicketType.MAINTAIN] ?? 0,
                                                    ticketStatistics[MaintainerConstants.TicketType.REPAIR] ?? 0,
                                                ],
                                                borderColor: [
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                ],
                                                backgroundColor: [
                                                    'rgba(111, 85, 249, 1)',
                                                    'rgba(248, 151, 47, 1)',
                                                ],
                                                borderWidth: 3,
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="flex-fill">
                                    {UIHelper.buildDoughnutChartLegend([
                                        {
                                            title: 'Bảo trì',
                                            color: 'rgba(111, 85, 249, 1)',
                                            value: ticketStatistics[MaintainerConstants.TicketType.MAINTAIN] ?? 0,
                                        },
                                        {
                                            title: 'Sửa chữa',
                                            color: 'rgba(248, 151, 47, 1)',
                                            value: ticketStatistics[MaintainerConstants.TicketType.REPAIR] ?? 0,
                                        },
                                        {
                                            title: 'Tổng số:',
                                            value: _.sum(_.values(ticketStatistics)),
                                        },
                                    ])}
                                </div>
                            </div>
                        </div>,
                        false,
                        false,
                        true,
                        true
                    )}
                </div>
                {/* thong ke trang thai ticket */}
                <div className="col-lg-6 mb-4 px-2">
                    {UIHelper.buildCard(
                        <div className='h-100'>
                            <div className='d-flex justify-content-between'>
                                {UIHelper.buildCardHeader('Thống kê trạng thái bảo trì/sửa chữa', false, null, false, true)}
                                <div className='p-4'>
                                    <CustomDateRangePicker
                                        alignRight={true}
                                        toggleFontWeight="600"
                                        toggleElementBorderRadius={10}
                                        initialValue={chartFilter.selectedValue}
                                        onPressSave={(selectedValue, startDate, endDate) => {
                                            setTicketSummaryFilter({
                                                from: startDate,
                                                to: endDate,
                                                selectedValue: selectedValue,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="px-4 pb-4 d-flex align-items-center gap-3 w-100">
                                <div
                                    className=""
                                    style={{
                                        height: '200px',
                                        width: '200px',
                                    }}
                                >
                                    <DoughnutChartJS
                                        showTitle={false}
                                        showLegend={false}
                                        labels={[
                                            'Chưa thực hiện',
                                            'Đã Check-in',
                                            'Chờ duyệt',
                                            'Đã duyệt',
                                            'Hoàn thành',
                                            'Đã hủy'
                                        ]}
                                        datasets={[
                                            {
                                                data: [
                                                    ticketSummary[MaintainerConstants.TicketStatus.TODO] ?? 0,
                                                    ticketSummary[MaintainerConstants.TicketStatus.CHECKIN] ?? 0,
                                                    ticketSummary[MaintainerConstants.TicketStatus.PENDING] ?? 0,
                                                    ticketSummary[MaintainerConstants.TicketStatus.APPROVAL] ?? 0,
                                                    ticketSummary[MaintainerConstants.TicketStatus.DONE] ?? 0,
                                                    ticketSummary[MaintainerConstants.TicketStatus.CANCEL] ?? 0,
                                                ],
                                                borderColor: [
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                ],
                                                backgroundColor: [
                                                    'rgba(126, 130, 153, 1)',
                                                    'rgba(41, 132, 238, 1)',
                                                    'rgba(248, 174, 46, 1)',
                                                    'rgba(175, 82, 222, 1)',
                                                    'rgba(0, 193, 119, 1)',
                                                    'rgba(225, 78, 84, 1)'
                                                ],
                                                borderWidth: 3,
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="flex-fill">
                                    {UIHelper.buildDoughnutChartLegend([
                                        {
                                            title: 'Chưa thực hiện',
                                            color: 'rgba(126, 130, 153, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.TODO] ?? 0,
                                        },
                                        {
                                            title: 'Đã Check-in',
                                            color: 'rgba(41, 132, 238, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.CHECKIN] ?? 0,
                                        },
                                        {
                                            title: 'Chờ duyệt',
                                            color: 'rgba(248, 174, 46, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.PENDING] ?? 0,
                                        },
                                        {
                                            title: 'Đã duyệt',
                                            color: 'rgba(175, 82, 222, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.APPROVAL] ?? 0,
                                        },
                                        {
                                            title: 'Hoàn thành',
                                            color: 'rgba(0, 193, 119, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.DONE] ?? 0,
                                        },
                                        {
                                            title: 'Đã hủy',
                                            color: 'rgba(225, 78, 84, 1)',
                                            value: ticketSummary[MaintainerConstants.TicketStatus.CANCEL] ?? 0,
                                        },
                                        {
                                            title: 'Tổng số:',
                                            value: _.sum(_.values(ticketSummary)),
                                        },
                                    ])}
                                </div>
                            </div>
                            <div className='p-4'>
                                {UIHelper.buildNegativeButton(
                                    'Danh sách công việc của tôi',
                                    () => {
                                        router.navigate(AppRoute.myTicket);
                                    }
                                )}
                            </div>
                        </div>,
                        false,
                        false,
                        true,
                        true
                    )}
                </div>
                {/* thong ke cong viec da nhan */}
                <div className="col-lg-6 px-2 mb-4">{chartTicketByDateEl}</div>
            </div>


            <div className="px-4 mb-4">
                {UIHelper.buildCard(
                    <div>
                        {maintainCalendar}
                    </div>,
                    false
                )}
            </div>
        </div>
    );
}

export default MaintainerDashboardView;
